export const styles = {
  tab: {
    whiteSpace: "nowrap",
    "&.Mui-selected": { color: "grey900" },
    p: "4px 16px",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    gap: 3,
  },
  cardWrapper: {
    width: "300px",
    mx: "auto",

    "@media (max-width: 380px)": {
      width: "100%",
    },
  },
};
